import React, { useRef } from "react";
import Helmet from "react-helmet";
import { LocomotiveScrollProvider } from "react-locomotive-scroll";
import { Link } from "react-router-dom";
import clearLogo from "../../Utils/Images/youBClearLogo.png";
import logo from "../../Utils/Images/youBLogo.jpg";
import HeroGrid from "./Components/HeroGrid";
import MiniGrid from "./Components/MiniGrid";
import "./styles.css";

function Instructions() {
  const containerRef = useRef(null);

  return (
    <LocomotiveScrollProvider
      options={{
        smooth: true,
        // ... all available Locomotive Scroll instance options
      }}
      watch={
        [
          //..all the dependencies you want to watch to update the scroll.
          //  Basicaly, you would want to watch page/location changes
          //  For exemple, on Next.js you would want to watch properties like `router.asPath` (you may want to add more criterias if the instance should be update on locations with query parameters)
        ]
      }
      containerRef={containerRef}
    >
      <Helmet>
        <title>youB Self Reflection</title>
        <meta
          name="description"
          content="Find out Which Environmental and Social Values are Most Important to You."
        />
        <meta property="og:title" content="youB Self Reflection" />
        <meta
          property="og:description"
          content="Find out Which Environmental and Social Values are Most Important to You"
        />
        <meta property="og:site_name" content="youB Self Reflection" />
        <meta property="og:locale" content="en-US" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://youb-esr-app.web.app/" />
        <meta
          property="og:image"
          content="https://firebasestorage.googleapis.com/v0/b/youb-esr-app.appspot.com/o/home-images%2F1.png?alt=media&token=7cadf750-85df-48cf-8958-6f75345c8488"
        />
        {/* <link rel="icon" href="/icons/favicon.ico" /> */}
        {/* <link rel="stylesheet" href="../styles/Home.module.css" /> */}
        <meta http-equiv="X-UA-Compatible" content="IE=edge" />

        {/* This viewport line is what fixed the width issue!!!!!! */}
        {/* TRY TESTING NOW WITH LOCOMOTIVE */}
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      </Helmet>

      <main data-scroll-container id="instructions">
        <section
          className="tiles tiles--columns-rotated tiles--darker"
          id="grid"
        >
          <div className="titleOverlay" />
          <HeroGrid />
          <div className="tiles__title">
            <img src={clearLogo} alt={"youB Logo"} />
            <h2>Self Reflection</h2>
            <h3>What Environmental and Social Values are Most Important to Me?</h3>
          </div>
        </section>
        <section className="content">
          <p
            className="content__text content__text--centered"
            data-scroll
            data-scroll-speed="4"
          >
The youB community sees personal, societal, and environmental challenges as interwoven and we truly believe we can inspire the efforts to make change. We invite you to explore which youB Values call you to action. This 5-step self-reflection will help you to clarify which Values you most want to be informed about, inspired by, and motivated to act on at this time.
            <br />
            <br />
            Close your eyes. Take a deep breath. Feel into what you care deeply about, your concern for the world, and how you want to be part of the change. 
            <br />
            <br />
            Your final top five youB Values will guide you toward what you are passionate about and how you can make a difference.          </p>
        </section>

        <MiniGrid />
        <section className="content">
          <Link
            className="backtop"
            data-scroll
            data-scroll-speed="4"
            to={"/esr"}
          >
            Start
          </Link>
          <div className="footer">
            <a target="_blank"
            rel="noopener noreferrer" href="https://youb.com/">
              <img src={logo} className="logo" alt="youB Logo" />
            </a>

            <div className="frame__demos">
              <p>Copyright © 2022 by youB, Inc. All rights reserved.</p>
            </div>
          </div>
        </section>
      </main>
    </LocomotiveScrollProvider>
  );
}

export default Instructions;
